import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  updateHouseShipmentContainerNumber,
  updateHouseShipmentGeneralInformation,
  updateHouseShipmentHBLType,
  updateHouseShipmentSealNumber,
} from './houseShipments.service'
import { updateShipmentInformation } from './shipments.service'

export const useShipmentInformationUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateShipmentInformation,
    onSuccess: async (_, vars) => {
      await queryClient.invalidateQueries({
        queryKey: ['shipments', vars.shipmentId],
      })
    },
  })
}

export const useHouseShipmentContainerNumberUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateHouseShipmentContainerNumber,
    onSuccess: async (_, { houseShipmentCode, houseCargoID }) => {
      await queryClient.invalidateQueries({
        queryKey: ['house-shipment-container-number', houseShipmentCode, houseCargoID],
      })
    },
  })
}

export const useHouseShipmentSealNumberUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateHouseShipmentSealNumber,
    onSuccess: async (_, { houseShipmentCode, houseCargoID }) => {
      await queryClient.invalidateQueries({
        queryKey: ['house-shipment-seal-number', houseShipmentCode, houseCargoID],
      })
    },
  })
}

export const useHouseShipmentHBLTypeUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateHouseShipmentHBLType,
    onSuccess: async (_, { houseShipmentCode }) => {
      await queryClient.invalidateQueries({
        queryKey: ['house-shipment-hbl-type', houseShipmentCode],
      })
    },
  })
}

export const useHouseShipmentGeneralInforamtionUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateHouseShipmentGeneralInformation,
    onSuccess: async (_, { shipmentCode }) => {
      await queryClient.invalidateQueries({
        queryKey: ['house-shipment', shipmentCode],
      })
    },
  })
}
